<input #fileInput type="file" [id]="id" [multiple]="multiple" [accept]="accept" [disabled]="disabled" (change)="_onFilesSelected($event)"
    [attr.aria-label]="ariaLabel" [attr.aria-labelledby]="ariaLabelledby">
<ng-content select="np-drop-zone-label" *ngIf="!_hasPreviews"></ng-content>
<ng-content select="np-drop-zone-preview"></ng-content>
<ng-content></ng-content>